export enum ErknmPlanStatusesEnum {
  IN_PROCESS = 'IN_PROCESS',
  UNDER_CONSIDERATION = 'UNDER_CONSIDERATION',
  CONSIDERED = 'CONSIDERED',
  APPROVED = 'APPROVED',
}
